import React from "react";
import "./MahabaleshwarLonavalaPackage.css";

const itinerary = [
  {
    day: "Day 1",
    places: ["Pune", "Mahabaleshwar"],
    stay: "Night Stay – Mahabaleshwar",
  },
  {
    day: "Day 2",
    places: [
      "Mahabaleshwar Local Sightseeing",
      "Mapro Garden",
      "Venna Lake",
      "View Points",
    ],
    stay: "Night Stay – Mahabaleshwar",
  },
  {
    day: "Day 3",
    places: ["Mahabaleshwar", "Panchgani", "Lonavala"],
    stay: "Night Stay – Lonavala",
  },
  {
    day: "Day 4",
    places: [
      "Lonavala Local Sightseeing",
      "Khandala",
      "Bhushi Dam",
      "Tiger Point",
    ],
    stay: "Night Stay – Lonavala",
  },
  {
    day: "Day 5",
    places: ["Lonavala", "Pune"],
    stay: "Return to Pune",
  },
];

const vehicles = [
  { name: "Sedan Cab", price: "₹21,000", icon: "🚘" },
  { name: "Ertiga Cab", price: "₹25,500", icon: "🚙" },
  { name: "Kia Carens", price: "₹30,000", icon: "🚗" },
  {
    name: "Innova Crysta",
    price: "₹33,000",
    icon: "🚐",
    popular: true,
  },
  { name: "Innova Hycross", price: "₹42,000", icon: "🚐" },
  { name: "Winger 9+1", price: "₹43,500", icon: "🚐" },
  { name: "Winger 12+1", price: "₹45,000", icon: "🚐" },
  { name: "Tempo Traveller 17 Seater", price: "₹47,000", icon: "🚌" },
  { name: "Tempo Traveller 20 Seater", price: "₹53,000", icon: "🚌" },
];

export default function MahabaleshwarLonavalaPackage() {
  return (
    <section className="ml-package">
      <div className="ml-container">

        {/* HEADER */}
        <div className="ml-header">
          <div className="ml-logo-box">
            <img
              src="/images/logo.jpg"
              alt="Garud Cabs"
              className="ml-logo"
            />
          </div>

          <div className="ml-header-content">
            <span className="ml-badge">4 Nights • 5 Days</span>

            <h1>
              Pune to Mahabaleshwar
              <span> & Lonavala Package</span>
            </h1>

            <p>
              Enjoy a comfortable 5-day hill station tour covering
              Mahabaleshwar, Panchgani, Lonavala and Khandala with Garud
              Cabs.
            </p>
          </div>
        </div>

        {/* ROUTE */}
        <div className="ml-route">
          <span className="ml-route-label">TOUR ROUTE</span>

          <div className="ml-route-text">
            Pune <b>→</b> Mahabaleshwar <b>→</b> Panchgani
            <b> → </b> Lonavala <b>→</b> Khandala <b>→</b> Pune
          </div>
        </div>

        {/* MAIN AREA */}
        <div className="ml-main-grid">

          {/* ITINERARY */}
          <div className="ml-card ml-itinerary">
            <div className="ml-section-title">
              <div className="ml-number">05</div>

              <div>
                <small>COMPLETE TOUR PLAN</small>
                <h2>5-Day Itinerary</h2>
              </div>
            </div>

            <div className="ml-timeline">
              {itinerary.map((item, index) => (
                <div className="ml-timeline-item" key={item.day}>

                  <div className="ml-day-number">
                    {index + 1}
                  </div>

                  <div className="ml-day-content">
                    <h3>{item.day}</h3>

                    <div className="ml-places">
                      {item.places.map((place, i) => (
                        <React.Fragment key={place}>
                          <span>{place}</span>

                          {i !== item.places.length - 1 && (
                            <b>→</b>
                          )}
                        </React.Fragment>
                      ))}
                    </div>

                    <div className="ml-stay">
                      🏨 {item.stay}
                    </div>
                  </div>

                </div>
              ))}
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="ml-side">

            {/* INCLUDED */}
            <div className="ml-card ml-included">
              <span className="ml-small-label">
                ALL-INCLUSIVE PACKAGE
              </span>

              <h2>Everything Included</h2>

              <div className="ml-included-grid">
                <div>✓ Fuel Charges</div>
                <div>✓ Toll Charges</div>
                <div>✓ Parking Charges</div>
                <div>✓ Driver Allowance</div>
                <div>✓ Driver Food</div>
                <div>✓ Complete Cab Charges</div>
              </div>

              <div className="ml-inclusive-note">
                ✓ All Transportation Charges Included
              </div>
            </div>

            {/* TOUR */}
            <div className="ml-card ml-tour-info">
              <h3>🏔️ Tour Highlights</h3>

              <div className="ml-info-row">
                <span>Destination</span>
                <strong>Mahabaleshwar</strong>
              </div>

              <div className="ml-info-row">
                <span>Destination</span>
                <strong>Panchgani</strong>
              </div>

              <div className="ml-info-row">
                <span>Destination</span>
                <strong>Lonavala & Khandala</strong>
              </div>

              <div className="ml-info-row">
                <span>Duration</span>
                <strong>4 Nights / 5 Days</strong>
              </div>
            </div>

            <div className="ml-package-note">
              <strong>All-Inclusive Cab Package</strong>
              <p>
                Fuel, toll, parking, driver allowance and transportation
                expenses are included in the package price.
              </p>
            </div>

          </div>
        </div>

        {/* PRICE */}
        <div className="ml-pricing">

          <div className="ml-pricing-head">
            <div>
              <span className="ml-small-label">
                CHOOSE YOUR VEHICLE
              </span>
              <h2>5-Day Package Price</h2>
            </div>

            <p>Complete Pune Round Trip Package</p>
          </div>

          <div className="ml-vehicle-grid">

            {vehicles.map((vehicle) => (
              <div
                className={`ml-vehicle-card ${
                  vehicle.popular ? "ml-popular" : ""
                }`}
                key={vehicle.name}
              >
                {vehicle.popular && (
                  <span className="ml-popular-tag">
                    MOST POPULAR
                  </span>
                )}

                <div className="ml-vehicle-icon">
                  {vehicle.icon}
                </div>

                <div className="ml-vehicle-info">
                  <h3>{vehicle.name}</h3>
                  <small>All-Inclusive Package</small>
                </div>

                <div className="ml-price">
                  {vehicle.price}
                </div>
              </div>
            ))}

          </div>
        </div>

        {/* CTA */}
        <div className="ml-booking">

          <div>
            <span>GARUD CABS • PUNE</span>

            <h2>
              Book Your Mahabaleshwar & Lonavala Tour
            </h2>

            <p>
              Commercial Cab • Professional Driver • All-Inclusive Package
            </p>
          </div>

          <a
            href="tel:+919970007784"
            className="ml-book-btn"
          >
            Book Your Cab →
          </a>

        </div>

      </div>
    </section>
  );
}